import { render } from "./sign.vue?vue&type=template&id=973d01fe"
import script from "./sign.vue?vue&type=script&lang=js"
export * from "./sign.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/sign.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "973d01fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('973d01fe', __exports__)) {
    console.log('reload')
    api.reload('973d01fe', __exports__)
  }
  
  module.hot.accept("./sign.vue?vue&type=template&id=973d01fe", () => {
    console.log('re-render')
    api.rerender('973d01fe', render)
  })

}


export default __exports__